import BrandEquity from "./BrandEquity";

export default BrandEquity;
